import { ERROR_CODE as s } from "../../temp-lib/constants/error.js";
import { WalletType as n } from "../../temp-lib/constants/web3.js";
import { useAccountContext as m } from "../../temp-lib/contexts/account/AccountContext.js";
import { useMessageContext as p } from "../../temp-lib/contexts/share/MessageContext.js";
import { CustomError as a } from "../../temp-lib/errors/customError.js";
import i from "../../temp-lib/hooks/errors/useErrorHandler.js";
import { useCallback as u } from "react";
const g = () => {
  const { getErrorMessage: r } = i(), { showGeneralError: t } = p(), { setMissWallet: e } = m();
  return {
    showErrorPopup: u(
      (o) => {
        if (o instanceof a && o.code === s.LOGIN.NOT_YET_INSTALL_WALLET) {
          e(n.Ronin);
          return;
        }
        t(r(o));
      },
      [r, t, e]
    )
  };
};
export {
  g as default
};
//# sourceMappingURL=useMktErrorHandling.js.map
